// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Q53x","actionsCol":"EnrolledClinics_actionsCol__3iIin"};